import React from 'react';
import ReactDOM from 'react-dom';
import './Style.scss';
import VideoPG from './VideoPG';

ReactDOM.render(
  <React.StrictMode>
    <VideoPG />
  </React.StrictMode>,
  document.getElementById('root')
);
